const state = {
  candidates: [],
  footer: "",
  show: false,
  title: "Missing Title",
  x: 0,
  y: 0,
  isLeftOfMapCenter: false,
  isAboveMapCenter: false,
};

const mutations = {
  SET_CANDIDATES(state, candidates) {
    state.candidates = candidates;
  },
  SET_FOOTER(state, footer) {
    state.footer = footer;
  },
  SET_SHOW(state, show) {
    state.show = show;
  },
  SET_TITLE(state, title) {
    state.title = title;
  },
  SET_X(state, x) {
    state.x = x;
  },
  SET_Y(state, y) {
    state.y = y;
  },
  SET_IS_LEFT_OF_MAP_CENTER(state, isLeftOfMapCenter) {
    state.isLeftOfMapCenter = isLeftOfMapCenter;
  },
  SET_IS_ABOVE_MAP_CENTER(state, isAboveMapCenter) {
    state.isAboveMapCenter = isAboveMapCenter;
  },
};

const actions = {
  setTooltipCandidates(context, candidates) {
    context.commit("SET_CANDIDATES", candidates);
  },
  setTooltipFooter(context, footer) {
    context.commit("SET_FOOTER", footer);
  },
  showTooltip(context) {
    context.commit("SET_SHOW", true);
  },
  hideTooltip(context) {
    context.commit("SET_SHOW", false);
  },
  setTooltipTitle(context, title) {
    context.commit("SET_TITLE", title);
  },
  setTooltipX(context, x) {
    context.commit("SET_X", x);
  },
  setTooltipY(context, y) {
    context.commit("SET_Y", y);
  },
  setTooltipIsLeftOfMapCenter(context, isLeftOfMapCenter) {
    context.commit("SET_IS_LEFT_OF_MAP_CENTER", isLeftOfMapCenter);
  },
  setTooltipIsAboveMapCenter(context, isAboveMapCenter) {
    context.commit("SET_IS_ABOVE_MAP_CENTER", isAboveMapCenter);
  },
};

const getters = {
  candidates(state) {
    return state.candidates;
  },
  footer(state) {
    return state.footer;
  },
  show(state) {
    return state.show;
  },
  title(state) {
    return state.title;
  },
  x(state) {
    return state.x;
  },
  y(state) {
    return state.y;
  },
  isLeftOfMapCenter(state) {
    return state.isLeftOfMapCenter;
  },
  isAboveMapCenter(state) {
    return state.isAboveMapCenter;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
